import '../css/network-error.css';
import React from 'react';
import { connect } from 'react-redux';
import { moveOnToNextPage, networkRetry } from '../redux/actions/ui';

interface DataProps {
  error: boolean;
}

const dispatchToProps = {
  moveOnToNextPage,
  networkRetry
};

type Props = DataProps & typeof dispatchToProps;

function NetworkError(props: Props) {
  const { error } = props;
  const onSubmit = (): void => {
    props.networkRetry();
    props.moveOnToNextPage();
  };

  return (
    <div className='networkError'>
      <div>
        The connection to the server failed.{' '}
        {error ? 'Please try again.' : 'Retrying...'}
      </div>
      {error ? (
        <button onClick={onSubmit} className={'networkErrorButton'}>
          Try Again
        </button>
      ) : null}
    </div>
  );
}

export default connect(null, dispatchToProps)(NetworkError);
